import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CompilationsDataService } from 'quest-atlas-angular-components';

@Injectable({
  providedIn: 'root'
})
export class TripShareService {
  constructor(private compilationsService: CompilationsDataService) {}

  /**
   * Generate a share link for a trip/compilation
   * @param compilationId - The ID of the compilation
   * @param isMine - Whether the current user owns this compilation
   * @returns Observable of the share URL
   */
  getShareLink(compilationId: number, isMine: boolean): Observable<string> {
    const baseUrl = window.location.origin;

    if (isMine) {
      // For owned trips, create a share token
      return this.compilationsService.createShareToken(compilationId)
        .pipe(
          map(token => `${baseUrl}/accept-share/compilation/${token.token}`)
        );
    } else {
      // For public trips, use direct link
      return of(`${baseUrl}/show-compilation/${compilationId}`);
    }
  }

  /**
   * Copy text to clipboard
   * @param text - The text to copy
   * @returns Promise that resolves when copied
   */
  copyToClipboard(text: string): Promise<void> {
    return navigator.clipboard.writeText(text);
  }
}

